import type {ChannelExpandedCommon} from '../../../../../api/channel';
import type {StrategyByType} from './types';

import {getSupportLogoFile} from '../../../../../utils/entity/file';
import {isUserHasRole} from '../../../../../utils/entity/user';

export class ChannelSupportStrategy implements StrategyByType {
  getAvatar(_channel: ChannelExpandedCommon) {
    return getSupportLogoFile(340);
  }

  getClientName(_channel: ChannelExpandedCommon) {
    return null;
  }

  getClientSource(_channel: ChannelExpandedCommon) {
    return null;
  }

  getDescription(_channel: ChannelExpandedCommon) {
    return '';
  }

  getIsArchived(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsCorporate(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsEnded(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsIndividual(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsNewClient(_channel: ChannelExpandedCommon) {
    return false;
  }

  getIsOneToOne(channel: ChannelExpandedCommon) {
    return channel.user_ids.length === 2;
  }

  getIsStarted(_channel: ChannelExpandedCommon) {
    return false;
  }

  getTitle(channel: ChannelExpandedCommon) {
    const client = channel.members.find(
      member => !isUserHasRole('support', member),
    );

    return [
      channel.title,
      isUserHasRole('support') && client ? ` (${client.name})` : null,
    ]
      .filter(Boolean)
      .join('');
  }

  getUserIsFrozen(_channel: ChannelExpandedCommon, _isUserCoach: boolean) {
    return false;
  }
}
